module.exports = __webpack_public_path__ + "static/primary-2c670534db81d93173a798239bf88d86.png";